import { Directive, Input, Output, ViewChild, EventEmitter, TemplateRef, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { HisSearchResultComponent } from './his-search-result.component';
import { HisSearchFormComponent } from './his-search.component';
import { HisOption } from '../model/his-option';
import { HisSearch, HisSearchGroup } from '../model/search/his-search';
import { HisSearchSelectionSetting } from '../model/his-search-selection-setting';

@Directive()
export class HisSearchFormResultComponentBase implements OnInit {
    private route = inject(ActivatedRoute);


    // Used to determine the relevant UI elements
    protected selectionSettingEnum = HisSearchSelectionSetting;
    @Input() selectionSetting: HisSearchSelectionSetting = HisSearchSelectionSetting.MultiSelect;

    @Input() renderTitle = true;

    @Input() renderCustomBottomResultButtons: boolean = true;

    @Input() scrollToResultAfterSearch: boolean = true;

    @Input() searchConfigFile: string;
    @Input() selectedOptions: any[] = [];
    @Input() selectedOptionsIdColumn: string = undefined;
    @Input() selectedOptionsLabelColumn: string = undefined;

    // is this a principal search? (not a sub-search in a popup)
    // only in this case we want to register the url for the "back to search" button
    @Input() isSearchPopup = false;

    // the number of result rows per page
    @Input() resultRowsPerPage = 10;

    // search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
    @Input() presetInputFields = {};

    // a CSS style that can be passed to the search result table
    @Input() resultTableStyle: any;
    @Input() hisIcon = 'arrow_left';

    @Input() customResultRowsTemplate: TemplateRef<any>;

    @ViewChild( 'SearchFormComponent', { static: true } ) searchFormComponent: HisSearchFormComponent;
    @ViewChild( 'SearchResultComponent', { static: true } ) searchResultComponent: HisSearchResultComponent;

    @Output() selectionSubmited: EventEmitter<any[]> = new EventEmitter();
    @Output() selectionCanceled: EventEmitter<void> = new EventEmitter();
    @Output() readSearchSetSubmit: EventEmitter<HisSearch> = new EventEmitter();

    @Output() finishedInitialLoad: EventEmitter<void> = new EventEmitter();

    @Output() formTitleLoaded: EventEmitter<string> = new EventEmitter();

    @Input() showTableFilter = true;

    @Input() defaultSearchGroup: HisSearchGroup;

    @Input() hiddenSearchCriteriaPaths: string[];

    @Input() genericSearchRowTooltipId: string;

    @Input() searchShowPrintviewButton = true;

    // Specifies the heading level for the <his-heading> component.
    @Input() hierarchyLevel: number;

    toggleFilter = false;

    ngOnInit() {
        this.route.queryParams.subscribe( (queryParams: Params) => {
            console.log( 'HisSearchFormResultComponent.ngOnInit(): queryParams=', queryParams, ', presets =', this.presetInputFields );
        } );
    }

    setSelectedOptions( selectedOptions: any[], selectedOptionsIdColumn: string ) {
        this.selectedOptions = ( selectedOptions ) ? selectedOptions.slice( 0 ) : [];
        this.selectedOptionsIdColumn = selectedOptionsIdColumn;
        this.searchResultComponent.setSelectedOptions( selectedOptions, selectedOptionsIdColumn, this.selectedOptionsLabelColumn );
    }

    submitInitialSearch() {
        let presets = this.searchFormComponent.presetInputFields;
        if ( presets && Object.keys( presets ).length > 0 ) {
            this.searchFormComponent.createHisSearchFromSearchData( this.searchConfigFile ).subscribe( (search: HisSearch) => {
                if ( search ) {
                    console.log( 'HisSearchFormResultComponent:submitInitialSearch() search =', search );
                    this.onSubmitSearch( search );
                }
            } );
        } // else: do not run initial search if no presets are present #255715
    }

    onSubmitSearch( search: HisSearch ) {
        // Die erste anzuzeigende Ergebniszeile muss bei Abschicken einer Suche auf 0 zurückgesetzt werden,
        // da es bei einer erneuten Suche mit geänderten Suchkriterien weniger Treffer als vorher geben kann.
        console.log(
            'HisSearchFormResultComponent.onSubmitSearch(): Initialize search result for ',
            this.searchConfigFile, 'with search constraints',
            search,
            'with page 1, rows 1..' + this.searchResultComponent.resultRowsPerPage );
        if (this.defaultSearchGroup) {
            if (search.groups) {
                search.groups.unshift(this.defaultSearchGroup);
            } else {
                search.groups = [this.defaultSearchGroup];
            }
        }
        this.searchResultComponent.loadPage( 0, search );
        this.readSearchSetSubmit.emit(search);
    }

    /**
     * Submit multiple selection.
     */
    submitSelection() {
        this.selectedOptions = this.searchResultComponent.selectedOptions.slice( 0 );
        console.log( 'HisSearchFormResultComponent.submitSelection(): Submit multi-selection:', this.selectedOptions );
        this.selectionSubmited.emit( this.selectedOptions );
    }

    /**
     * Submit single selection.
     */
    submitSingleSelection( selection: HisOption ) {
        console.log( 'HisSearchFormResultComponent.submitSingleSelection(): Submit single-selection:', selection );
        this.selectedOptions = [selection];
        this.selectionSubmited.emit( this.selectedOptions );
    }

    /**
     * Cancel button pressed -> forget the search result selection, just pass the event.
     */
    cancelSelection() {
        this.selectionCanceled.emit();
    }

    toggleTableFilter(toggle: boolean) {
        this.toggleFilter = toggle;
    }

    protected onFinishedInitialLoad() {
        // Das Timeout ist hier notwendig, damit erst dann gescrolled wird, wenn alle Oberflächenkomponenten fertig geladen sind
        if (this.scrollToResultAfterSearch) {
            setTimeout( () => { this.searchFormComponent.scrollToResult(); }, 1 );
        }
            
        this.finishedInitialLoad.emit();
    }

    protected onFormTitleLoaded( title: string ) {
        this.formTitleLoaded.emit( title );
    }
    
}
